
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressNode]",
      function () {
        return require("private-next-pages/[...wordpressNode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressNode]"])
      });
    }
  